<template>
  <figure :class="[`image`, playing ? 'playing': '']">
    <video class="has-ratio" :src="gif.url" loop @click="togglePlay" ref="video"></video>
    <div class="is-overlay play-button has-text-white">
      <b-icon icon="play-circle" class="fa-3x" aria-hidden="true"></b-icon>
    </div>
    <div class="is-overlay gif-icon">
      <span class="tag is-info">GIF</span>
    </div>
  </figure>
</template>

<script>
export default {
  name: "TweetGif",
  props: {
    gif: Object
  },
  data() {
    return {
      playing: false
    }
  },
  methods: {
    togglePlay() {
      this.playing = !this.playing;
      if (this.playing) {
        this.$refs.video.play()
      } else {
        this.$refs.video.pause()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

video {
  border-radius: 0.5rem;
  cursor: pointer;
  width: 100%;
}

.content figure {
  margin-left: 0;
  margin-right: 0;
}

.is-overlay {
  pointer-events: none;
  opacity: 0.75;
  transition: opacity 200ms ease;
}

.playing .is-overlay {
  opacity: 0;
}

.play-button {
  top: calc(50% - 0.5rem);
  text-align: center;
}

.gif-icon {
  top: inherit;
  bottom: 0.8rem;
  left: 0.5rem;
  text-align: left;
}
</style>
